import { render, staticRenderFns } from "./ContractTable.global.vue?vue&type=template&id=41b54703&lang=pug&"
import script from "./ContractTable.global.vue?vue&type=script&lang=ts&"
export * from "./ContractTable.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports